import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PageHeader } from "../components/Shared";
import { useLang } from "../context/LanguageContext";

const Pricing = () => {
  const { t } = useLang();
  const { PRICING, UI } = t;

  return (
    <div>
      <PageHeader eyebrow={PRICING.eyebrow} title={PRICING.title} subtitle={PRICING.subtitle} />

      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-6xl px-6">
          <div className="grid gap-8 lg:grid-cols-3 lg:items-stretch">
            {PRICING.plans.map((plan) => (
              <div
                key={plan.name}
                data-testid={`pricing-plan-${plan.name.toLowerCase()}`}
                className={`relative flex flex-col rounded-2xl border bg-white p-8 transition-shadow duration-300 hover:shadow-xl ${
                  plan.featured ? "border-blue-600 shadow-lg ring-1 ring-blue-600" : "border-slate-200"
                }`}
              >
                {plan.featured && (
                  <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-blue-700 px-4 py-1 text-xs font-bold uppercase tracking-wide text-white">
                    {plan.badge}
                  </span>
                )}
                <h3 className="text-xl font-bold text-slate-900">{plan.name}</h3>
                <p className="mt-2 min-h-[44px] text-[14px] leading-snug text-slate-600">{plan.desc}</p>
                <div className="mt-6 flex items-baseline gap-1.5">
                  <span className="text-4xl font-bold text-slate-900">{plan.price}</span>
                  <span className="text-sm text-slate-500">{plan.period}</span>
                </div>
                <ul className="mt-7 flex-1 space-y-3.5">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-[14.5px] text-slate-700">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-50">
                        <Check className="h-3 w-3 text-blue-700" strokeWidth={3} />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/book-demo"
                  data-testid={`pricing-cta-${plan.name.toLowerCase()}`}
                  className={`mt-8 inline-flex items-center justify-center rounded-lg px-6 py-3 text-[15px] font-semibold transition-colors duration-200 ${
                    plan.featured
                      ? "bg-blue-700 text-white hover:bg-blue-800"
                      : "border border-slate-200 bg-white text-slate-800 hover:border-slate-300 hover:bg-slate-50"
                  }`}
                >
                  {plan.cta}
                </Link>
              </div>
            ))}
          </div>

          <p data-testid="pricing-scope-note" className="mt-12 text-center text-sm text-slate-500">{UI.pricing.note}</p>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
